import { useUnreadNotificationCountQuery } from "@/src/graphql/generated";
import useGqlClient from "@/src/hooks/useGqlClient";
import { classNames } from "@/src/utils/cn";
import { useQueryClient } from "@tanstack/react-query";
import clsx from "clsx";
import { useEffect, useState } from "react";

export function NotificationDot(props: { className?: string }) {
  const client = useGqlClient();
  const queryClient = useQueryClient();
  const unreadNotificationCount = useUnreadNotificationCountQuery(
    client,
    {},
    {
      refetchOnWindowFocus: true,
      refetchInterval: 2000,
    },
  );
  const [previousCount, setPreviousCount] = useState(0);

  useEffect(() => {
    if (
      unreadNotificationCount.data &&
      previousCount !==
        unreadNotificationCount.data.account.unreadNotificationCount
    ) {
      queryClient.invalidateQueries({ queryKey: ["Notifications"] });
      setPreviousCount(
        unreadNotificationCount.data.account.unreadNotificationCount,
      );
    }
  }, [unreadNotificationCount.data, previousCount, queryClient]);

  if (
    !unreadNotificationCount.data ||
    unreadNotificationCount.data.account.unreadNotificationCount === 0
  ) {
    return null;
  }

  return (
    <div
      className={clsx(
        " m-[1px] px-[6px] py-[3px] bg-persian-800 rounded-full flex items-center justify-center",
        props.className ? props.className : "",
      )}
    >
      <p
        className={classNames(
          "text-white font-medium text-sm leading-none",
          unreadNotificationCount.data.account.unreadNotificationCount > 9
            ? "text-xs"
            : "",
        )}
      >
        {unreadNotificationCount.data.account.unreadNotificationCount}
      </p>
    </div>
  );
}
